import React from 'react';
import { Box } from '@mui/material';
import './Loader.scss';

export default function loader() {
  return (
    <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
    }}>
    <div className="loader" />
  </Box>
  )}